import { getResourceLabel } from 'SharedHelpers/getResourceLabel';

/**
 * getArticleContent
 *
 * @param {array} article
 * @return
 */

export const getArticleContent = (article) => {
  const articleDate = new Date(article.date);
  const resourceLabel = article && getResourceLabel(article);

  return {
    categories: article.categories || [],
    component: article.component || null,
    date: `${articleDate.getFullYear()}-${(articleDate.getMonth() + 1).toString().padStart(2, '0')}-${articleDate.getDate().toString().padStart(2, '0')}`,
    excerpt: article.excerpt || '',
    image: {
      src: (article.image && article.image.src) ? article.image.src : '',
      alt: (article.image && article.image.alt) ? article.image.alt : '',
    },
    isSponsored: article.isSponsored || false,
    kicker: article.kicker || '',
    link: article.link || '#',
    mediaType: article.primaryMediaType || 'IMAGE',
    rating: article.rating || false,
    resourceCategory: {
      resourceLabel,
    },
    title: article.title,
  };
};
